// Same rules as the approved prototype, with one deliberate widening: names may
// also carry combining marks (\p{M}, e.g. Arabic tashkeel in «نادٍ») and the
// typographic apostrophe.
export const emailOk = (s) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(s || '').trim());
export const nameOk = (s) => /^[\p{L}\p{M}\s'’-]+$/u.test(String(s || '').trim());
export const MIN_PASSWORD = 8;

/** "owner@cafe.sa" -> "o•••r@cafe.sa" (prototype's masked inbox address). */
export function maskEmail(email) {
  const e = String(email || '');
  const at = e.lastIndexOf('@');
  if (at < 1) return e;
  const local = e.slice(0, at);
  const chars = Array.from(local);
  const masked = chars.length <= 2 ? `${chars[0]}•••` : `${chars[0]}•••${chars[chars.length - 1]}`;
  return masked + e.slice(at);
}
